/* Pariah v9. Read-only size/stock filters. No pixels, cookies, cart mutations or inventory changes. */
(() => {
 'use strict';
 if (window.PariahSizeStockFilters) { window.PariahSizeStockFilters.init(); return; }
 const controllers = new WeakMap();
 const sizeNames = {XXS:'Extra extra small',XS:'Extra small',S:'Small',M:'Medium',L:'Large',XL:'Extra large',XXL:'Double extra large',XXXL:'Triple extra large'};
 const sizeOrder = ['XXS','XS','S','M','L','XL','XXL','XXXL','4XL','5XL','ONE SIZE'];
 function normalizeSize(value) {
  const raw = String(value || '').trim();
  const key = raw.toLowerCase().replace(/[\s._-]+/g, '');
  const names = {xxs:'XXS',xxsmall:'XXS',extraextrasmall:'XXS',xs:'XS',xsmall:'XS',extrasmall:'XS',s:'S',small:'S',m:'M',medium:'M',l:'L',large:'L',xl:'XL',xlarge:'XL',extralarge:'XL',xxl:'XXL','2xl':'XXL',xxlarge:'XXL',extraextralarge:'XXL',xxxl:'XXXL','3xl':'XXXL',xxxlarge:'XXXL',onesize:'ONE SIZE',os:'ONE SIZE',osfa:'ONE SIZE'};
  return names[key] || raw;
 }
 function sortSizes(a,b) {
  const ai=sizeOrder.indexOf(a), bi=sizeOrder.indexOf(b);
  if(ai>=0 || bi>=0) return (ai<0?999:ai)-(bi<0?999:bi);
  return a.localeCompare(b,undefined,{numeric:true,sensitivity:'base'});
 }
 function button(text, action) {
  const b=document.createElement('button');b.type='button';b.textContent=text;
  if(action)b.dataset.paFilterAction=action;
  return b;
 }
 function number(value, fallback) { const n=parseInt(value,10);return Number.isFinite(n)&&n>0?n:fallback; }
 class Filters {
  constructor(root) {
   this.root=root;this.q=s=>root.querySelector(s);this.grid=this.q('[data-pa-filter-grid]');
   this.source=new URL(location.href);this.section=root.dataset.paSectionId;
   this.pageParam=root.dataset.paPageParam||'page';this.pageSize=Math.min(250,number(root.dataset.paPageSize,24));
   this.pages=number(root.dataset.paPages,1);this.originalPage=number(root.dataset.paPage,1);
   this.abort=new AbortController();this.ready=false;this.bound=false;this.loading=false;
   this.q('[data-pa-filter-retry]').addEventListener('click',()=>this.boot(),{signal:this.abort.signal});
   this.boot();
  }
  readRecords(scope) {
   return [...scope.querySelectorAll('[data-pa-filter-record]')].map(node=>{
    const data=JSON.parse(node.dataset.paFilterRecord);
    if(!data.id || !Array.isArray(data.variants))throw new Error('Invalid filter data');
    const links=[...node.querySelectorAll('.pa-card-media,.pa-card-meta a')].map(a=>({a,href:a.getAttribute('href')}));
    const variants=data.variants.map(v=>({id:String(v.id),size:normalizeSize(v.size),inStock:v.inStock===true}));
    return {node,id:String(data.id),variants,links};
   });
  }
  async fetchPage(page) {
   const url=new URL(this.source);url.searchParams.set(this.pageParam,String(page));
   ['pa_size','pa_stock','pa_page','sections','section_id'].forEach(k=>url.searchParams.delete(k));
   url.searchParams.set('section_id',this.section);
   const timer=new AbortController();const timeout=setTimeout(()=>timer.abort(),18000);
   const stop=()=>timer.abort();this.abort.signal.addEventListener('abort',stop,{once:true});
   try {
    const response=await fetch(url.toString(),{credentials:'same-origin',cache:'no-store',signal:timer.signal});
    if(!response.ok)throw new Error('Filter page unavailable');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    const other=[...doc.querySelectorAll('[data-pa-filter-root]')].find(n=>n.dataset.paSectionId===this.section);
    if(!other || number(other.dataset.paPage,0)!==page || number(other.dataset.paPages,1)!==this.pages)throw new Error('Filter page changed; reload');
    return this.readRecords(other);
   } finally {clearTimeout(timeout);this.abort.signal.removeEventListener('abort',stop);}
  }
  async boot() {
   if(this.loading)return;this.loading=true;this.ready=false;
   this.q('[data-pa-filter-error]').hidden=true;this.q('[data-pa-filter-status-row]').hidden=false;
   this.q('[data-pa-filter-controls]').hidden=false;this.q('[data-pa-size-fieldset]').disabled=true;
   this.q('[data-pa-stock-only]').disabled=true;this.q('[data-pa-filter-count]').textContent='Loading size filters…';
   try {
    const pageRecords=new Map([[this.originalPage,this.readRecords(this.grid)]]);
    const pending=Array.from({length:this.pages},(_,i)=>i+1).filter(p=>p!==this.originalPage);
    // Fetch all result pages before enabling filters: never filter only the first 24 products.
    const worker=async()=>{while(pending.length&&!this.abort.signal.aborted){const p=pending.shift();pageRecords.set(p,await this.fetchPage(p));}};
    await Promise.all([worker(),worker()]);if(this.abort.signal.aborted || !this.root.isConnected)return;
    const seen=new Set();this.records=[];
    [...pageRecords.keys()].sort((a,b)=>a-b).forEach(p=>pageRecords.get(p).forEach(r=>{if(!seen.has(r.id)){seen.add(r.id);this.records.push(r);}}));
    this.sizes=[...new Set(this.records.flatMap(r=>r.variants.map(v=>v.size)).filter(Boolean))].sort(sortSizes);
    this.makeControls();this.records.forEach(r=>this.makeSizeLinks(r));this.bind();this.ready=true;
    this.q('[data-pa-size-fieldset]').disabled=false;this.q('[data-pa-stock-only]').disabled=false;
    this.q('[data-pa-filter-help]').hidden=false;
    this.root.querySelectorAll('[data-pa-native-pagination],[data-pa-native-empty]').forEach(n=>n.hidden=true);
    this.state=this.readState();this.apply(false);
   } catch(error) {
    if(!this.abort.signal.aborted){
     this.q('[data-pa-filter-controls]').hidden=true;this.q('[data-pa-filter-help]').hidden=true;
     this.q('[data-pa-filter-count]').textContent='Showing unfiltered products.';this.q('[data-pa-filter-error]').hidden=false;
     console.warn('Pariah size filters:',error.message);
    }
   } finally {this.loading=false;}
  }
  makeControls() {
   const host=this.q('[data-pa-size-options]');host.replaceChildren();
   const all=button('All sizes','all-sizes');all.className='pa-size-option';all.setAttribute('aria-pressed','true');host.append(all);
   this.sizeButtons=new Map();
   this.sizes.forEach(size=>{
    const b=button(size);b.className='pa-size-option';b.dataset.paSize=size;b.setAttribute('aria-pressed','false');
    const count=document.createElement('small');count.setAttribute('aria-hidden','true');b.append(count);
    host.append(b);this.sizeButtons.set(size,{b,count});
   });
   this.q('[data-pa-size-fieldset]').hidden=this.sizes.length===0;
  }
  makeSizeLinks(record) {
   const el=record.node.querySelector('[data-pa-card-sizes]');if(!el)return;
   const hasSizes=record.variants.some(v=>v.size);if(!hasSizes){el.hidden=true;return;}
   el.hidden=false;el.replaceChildren();
   const available=new Map();record.variants.filter(v=>v.size&&v.inStock).forEach(v=>{if(!available.has(v.size))available.set(v.size,v);});
   if(!available.size){el.textContent='Currently sold out in every size.';return;}
   el.append(document.createTextNode('In stock: '));
   [...available.keys()].sort(sortSizes).forEach(size=>{
    const a=document.createElement('a');a.textContent=size;a.dataset.paCardSize=size;
    const url=new URL(record.links[0].href,location.origin);url.searchParams.set('variant',available.get(size).id);a.href=url.pathname+url.search;
    a.setAttribute('aria-label',`View ${record.node.querySelector('h3')?.textContent.trim()||'piece'} in ${sizeNames[size]||size}`);el.append(a);
   });
  }
  readState() {
   const p=new URL(location.href).searchParams;
   const selected=new Set(p.getAll('pa_size').flatMap(x=>x.split(',')).map(normalizeSize).filter(Boolean));
   const stock=p.get('pa_stock')==='1';
   return {selected,stock,page:number(p.get(selected.size||stock?'pa_page':this.pageParam),1)};
  }
  match(record, selected=this.state.selected, stock=this.state.stock) {
   return record.variants.some(v=>(!selected.size || selected.has(v.size))&&(!stock || v.inStock));
  }
  stateUrl() {
   const url=new URL(location.href);['pa_size','pa_stock','pa_page',this.pageParam].forEach(k=>url.searchParams.delete(k));
   if(this.state.selected.size)url.searchParams.set('pa_size',[...this.state.selected].sort(sortSizes).join(','));
   if(this.state.stock)url.searchParams.set('pa_stock','1');
   if(this.state.page>1)url.searchParams.set(this.state.selected.size||this.state.stock?'pa_page':this.pageParam,String(this.state.page));
   return url;
  }
  preserveSort() {
   const form=this.q('[data-pa-filter-sort]');if(!form)return;
   const host=form.querySelector('[data-pa-filter-persist]');host.replaceChildren();
   this.stateUrl().searchParams.forEach((value,key)=>{
    if([this.pageParam,'pa_page','sort_by','sections','section_id'].includes(key))return;
    const input=document.createElement('input');input.type='hidden';input.name=key;input.value=value;host.append(input);
   });
  }
  apply(writeHistory=true) {
   if(!this.ready)return;
   const matches=this.records.filter(r=>this.match(r));const pages=Math.max(1,Math.ceil(matches.length/this.pageSize));
   this.state.page=Math.max(1,Math.min(this.state.page,pages));
   const first=(this.state.page-1)*this.pageSize;const shown=matches.slice(first,first+this.pageSize);
   this.grid.replaceChildren(...shown.map(r=>r.node));
   this.q('[data-pa-filter-empty]').hidden=matches.length!==0;
   const count=this.q('[data-pa-filter-count]');
   count.textContent=matches.length>this.pageSize?`Showing ${first+1}–${first+shown.length} of ${matches.length} pieces`:`${matches.length} ${matches.length===1?'piece':'pieces'}`;
   const active=this.state.selected.size>0||this.state.stock;
   this.root.querySelectorAll('[data-pa-clear-filters]').forEach(b=>{b.hidden=!active;});
   this.q('[data-pa-stock-only]').checked=this.state.stock;
   this.q('[data-pa-filter-action="all-sizes"]').setAttribute('aria-pressed',String(!this.state.selected.size));
   this.sizeButtons.forEach(({b,count},size)=>{
    const n=this.records.filter(r=>this.match(r,new Set([size]),this.state.stock)).length;
    count.textContent=String(n);b.dataset.paEmpty=String(n===0);b.setAttribute('aria-pressed',String(this.state.selected.has(size)));
    b.setAttribute('aria-label',`${sizeNames[size]||size}: ${n} ${this.state.stock?'in-stock ':''}${n===1?'piece':'pieces'}`);
   });
   // A size filter leads to that variant; cards and stock links never add to the cart automatically.
   shown.forEach(r=>{
    const choices=r.variants.filter(v=>this.state.selected.has(v.size));const variant=choices.find(v=>v.inStock)||choices[0];
    r.links.forEach(({a,href})=>{const u=new URL(href,location.origin);if(variant)u.searchParams.set('variant',variant.id);a.href=u.pathname+u.search+u.hash;});
    r.node.querySelectorAll('[data-pa-card-size]').forEach(a=>{if(this.state.selected.has(a.dataset.paCardSize))a.setAttribute('aria-current','true');else a.removeAttribute('aria-current');});
   });
   const nav=this.q('[data-pa-filter-pagination]');nav.replaceChildren();nav.hidden=pages<=1;
   if(pages>1){const prev=button('← Previous','previous'),next=button('Next →','next'),status=document.createElement('span');prev.disabled=this.state.page===1;next.disabled=this.state.page===pages;status.textContent=`Page ${this.state.page} of ${pages}`;nav.append(prev,status,next);}
   this.preserveSort();
   if(writeHistory){const url=this.stateUrl();if(url.href!==location.href)try{history.pushState(history.state,'',url);}catch(_){/* Filters still work when browser history is restricted. */}}
  }
  bind() {
   if(this.bound)return;this.bound=true;
   this.root.addEventListener('click',event=>{
    const b=event.target.closest('button');if(!b||!this.ready||b.disabled)return;
    let changed=true,paging=false;
    if(b.hasAttribute('data-pa-size')){const s=b.dataset.paSize;this.state.selected.has(s)?this.state.selected.delete(s):this.state.selected.add(s);this.state.page=1;}
    else if(b.dataset.paFilterAction==='all-sizes'){this.state.selected.clear();this.state.page=1;}
    else if(b.hasAttribute('data-pa-clear-filters')){this.state.selected.clear();this.state.stock=false;this.state.page=1;}
    else if(b.dataset.paFilterAction==='previous'){this.state.page--;paging=true;}
    else if(b.dataset.paFilterAction==='next'){this.state.page++;paging=true;}
    else changed=false;
    if(changed){this.apply();if(paging){const count=this.q('[data-pa-filter-count]');count.tabIndex=-1;count.focus({preventScroll:true});count.scrollIntoView({block:'center',behavior:'auto'});}}
   },{signal:this.abort.signal});
   this.q('[data-pa-stock-only]').addEventListener('change',event=>{if(this.ready){this.state.stock=event.target.checked;this.state.page=1;this.apply();}},{signal:this.abort.signal});
   this.q('[data-pa-filter-sort]')?.addEventListener('submit',()=>this.preserveSort(),{signal:this.abort.signal});
   window.addEventListener('popstate',()=>{if(this.ready&&this.root.isConnected){this.state=this.readState();this.apply(false);}},{signal:this.abort.signal});
  }
  destroy(){this.abort.abort();}
 }
 function init(scope=document) { scope.querySelectorAll('[data-pa-filter-root]').forEach(root=>{if(!controllers.has(root)){const controller=new Filters(root);controllers.set(root,controller);}}); }
 window.PariahSizeStockFilters={init};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
 document.addEventListener('shopify:section:load',e=>init(e.target));
 document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-pa-filter-root]').forEach(root=>{controllers.get(root)?.destroy();controllers.delete(root);}));
})();
